module.exports = __webpack_public_path__ + "img/new_32.4d868f5c.jpg";